import React, { useMemo, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { X } from "lucide-react";
import useTickets from "../../services/Support/useTickets";
import "./ClientTicket.css";

const DEPTS = ["Finance", "Orders", "Technical", "General"];

const RaiseTicketModal = ({ open, onClose }) => {

  const { raiseTicket } = useTickets();

  const [subject, setSubject] = useState("");
  const [department, setDepartment] = useState(DEPTS[0]);
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);

  const ticketCode = useMemo(() => {
    const t = Date.now().toString().slice(-8);
    return `T${t}`;
  }, [open]);

  const canSubmit = subject.trim() && description.trim();

  const submit = async () => {

    if (!canSubmit) {
      toast.info("Please fill subject and description");
      return;
    }

    setSaving(true);

    const res = await raiseTicket({
      subject: subject.trim(),
      description: description.trim(),
      department,
    });

    if (res?.responseCode === "00") {

      toast.success("Ticket raised successfully");

      setSubject("");
      setDepartment(DEPTS[0]);
      setDescription("");

      onClose(true);

    } else {
      toast.error(res?.responseMessage || "Failed to raise ticket");
    }

    setSaving(false);
  };

  if (!open) return null;

  return (
<>
<ToastContainer/>
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/10 montserrat-font-1">

      <div className="bg-white w-[480px] rounded-lg shadow-xl montserrat-font-1">

        {/* HEADER */}

        <div className="flex justify-between items-center px-6 py-4 border-b montserrat-font-1">

          <h2 className="text-lg font-semibold">
            Raise Support Ticket
          </h2>

          <button
            onClick={() => onClose(false)}
            className="text-gray-500 hover:text-black"
          >
            <X size={20} />
          </button>

        </div>


        {/* BODY */}

        <div className="p-6 space-y-4 montserrat-font-1">

          <div className="text-sm text-gray-500">
            Ticket Code: <span className="font-semibold">{ticketCode}</span>
          </div>

          {/* SUBJECT */}

          <div>

            <label className="text-sm text-gray-600">
              Subject
            </label>

            <input
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Brief subject"
              className="w-full mt-1 border rounded-md px-3 py-2 focus:ring-2 focus:ring-blue-500"
            />

          </div>


          {/* DEPARTMENT */}

          <div>

            <label className="text-sm text-gray-600 montserrat-font-1">
              Department
            </label>

            <select
              value={department}
              onChange={(e) => setDepartment(e.target.value)}
              className="w-full mt-1 border rounded-md px-3 py-2"
            >

              {DEPTS.map((d) => (
                <option key={d} value={d}>
                  {d}
                </option>
              ))}

            </select>

          </div>


          {/* DESCRIPTION */}

          <div>

            <label className="text-sm text-gray-600 montserrat-font-1">
              Description
            </label>

            <textarea
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Describe your issue..."
              className="w-full mt-1 border rounded-md px-3 py-2"
            />

          </div>

        </div>


        {/* FOOTER */}

        <div className="flex justify-end gap-3 px-6 py-4 border-t montserrat-font-1">

          <button
            onClick={() => onClose(false)}
            className="px-4 py-2 border rounded-md hover:bg-gray-100"
          >
            Cancel
          </button>

          <button
            onClick={submit}
            disabled={!canSubmit || saving}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
          >
            {saving ? "Submitting..." : "Submit Ticket"}
          </button>

        </div>

      </div>

    </div>
    </>
  );
};

export default RaiseTicketModal;